module.exports = __webpack_public_path__ + "img/alaska-map.186f41c7.png";